import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { Observable } from 'rxjs';
import { User } from '../../models';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) { }

  public register(user: User): Observable<any> {
    return this.http.post(environment.host + '/users', user);
  }

  public login(user: User) {
    return this.http.post<{
      code: string,
      data: {
        access: string,
        refresh: string,
        first_name: string,
        last_name: string;
        role: string;
        specialist_id?: string;
        balance?: number;
        isOnlineVeterinary?: boolean;
      }
    }> (environment.host + '/token/', user);
  }

  public logout(): void {
    this.localStorageService.set('token', '');
    this.localStorageService.set('user', '');
    window.location.href = '/';
  }
}
